<template>
    <div>
        <table class="table table-responsive-sm">
            <thead>
                <tr>
                    <th>{{ $t("labels.drug") }}</th>
                    <th>{{ $t("labels.quantity") }}</th>
                    <th>{{ $t("labels.drugNotes") }}</th>
                    <th>{{ $t("labels.startDate") }}</th>
                    <th>{{ $t("labels.endDate") }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="d in therapyDrugs" :key="d._id">
                    <td>{{ d.drugId.name[$i18n.locale] ? d.drugId.name[$i18n.locale] : d.drugId.name['en'] }}</td>
                    <td>{{ d.quantity }}</td>
                    <td>{{ d.notes }}</td>
                    <td>{{ formatDate(d.startDate) }}</td>
                    <td>{{ d.endDate != 'null' && d.endDate != null ? formatDate(d.endDate) : '-' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    props: {
      therapyDrugs: Array
    },
    methods: {
      formatDate(d) {
        try {
          let value =  moment(new Date(d)).format('LL')
          if (value == 'Invalid date')
            throw 'error'
          else
            return value
         }catch(e)  {
            return moment(d).format('DD MMMM Y')
         }

        },
    }
}
</script>
